import { render, staticRenderFns } from "./PageStateError.vue?vue&type=template&id=6aa3b9b2&"
import script from "./PageStateError.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PageStateError.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports